import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { sendTrack } from './lib/track';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import HeroSection from './components/sections/HeroSection';
import ServicesSection from './components/sections/ServicesSection';
import ArsenalSection from './components/sections/ArsenalSection';
import ProductCardsSection from './components/sections/ProductCardsSection';
import ComponentsSection from './components/sections/ComponentsSection';
import CustomSection from './components/sections/CustomSection';
import PhilosophySection from './components/sections/PhilosophySection';
import FaqSection from './components/sections/FaqSection';
import ContactSection from './components/sections/ContactSection';
import LandlinkPage from './views/LandlinkPage';
import BizpulsePage from './views/BizpulsePage';
import KnowhowHubPage from './views/KnowhowHubPage';
import PromoPage from './views/PromoPage';
import HiddenLeadsPage from './views/HiddenLeadsPage';
import DiagnosticPage from './views/DiagnosticPage';
import PartnerPage from './views/PartnerPage';
import PartnerDashboardPage from './views/PartnerDashboardPage';

function HomePage() {
  return (
    <main>
      <HeroSection />
      <ServicesSection />
      <ArsenalSection />
      <ProductCardsSection />
      <ComponentsSection />
      <CustomSection />
      <PhilosophySection />
      <FaqSection />
      <ContactSection />
    </main>
  );
}

export function AppRoutes() {
  const { pathname } = useLocation();
  const firstRender = useRef(true);

  // SPA 路由變化追蹤（首次載入由 prerender 注入的 beacon 負責，故跳過首次）
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    sendTrack();
  }, [pathname]);
  const standalonePages = [
    '/landlink',
    '/bizpulse',
    '/knowhow',
    '/promo',
    '/xyz',
    '/diagnosis',
    '/partner',
    '/partner-dashboard',
    '/knowhow-wa-gateway',
    '/knowhow-rules',
    '/knowhow-review',
  ];
  const isStandalone = standalonePages.some(p => pathname.startsWith(p));

  return (
    <div className={isStandalone ? '' : 'min-h-screen bg-jkd-black text-white overflow-x-hidden'}>
      {!isStandalone && <Navbar />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        {/* 靜態預渲染語言目錄（dist/<locale>/index.html ×6）的 SPA 配對路由 */}
        <Route path="/en/*" element={<HomePage />} />
        <Route path="/zh-CN/*" element={<HomePage />} />
        <Route path="/ms/*" element={<HomePage />} />
        <Route path="/ar/*" element={<HomePage />} />
        <Route path="/es/*" element={<HomePage />} />
        <Route path="/landlink/*" element={<LandlinkPage />} />
        <Route path="/bizpulse/*" element={<BizpulsePage />} />
        <Route path="/knowhow" element={<KnowhowHubPage />} />
        <Route path="/promo/*" element={<PromoPage />} />
        <Route path="/xyz" element={<HiddenLeadsPage />} />
        <Route path="/diagnosis/*" element={<DiagnosticPage />} />
        <Route path="/partner" element={<PartnerPage />} />
        <Route path="/partner-dashboard" element={<PartnerDashboardPage />} />
        {/* 舊路徑重定向到集合頁對應 TAB（2026-08-22 起全部集合於 /knowhow） */}
        <Route path="/knowhow-wa-gateway" element={<Navigate to="/knowhow#manual-cloudwapi" replace />} />
        <Route path="/knowhow-cloudwapi" element={<Navigate to="/knowhow#manual-cloudwapi" replace />} />
        <Route path="/knowhow-rules" element={<Navigate to="/knowhow#rules" replace />} />
        <Route path="/knowhow-review" element={<Navigate to="/knowhow#reviews" replace />} />
      </Routes>
      {!isStandalone && <Footer />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
